// Common
import config from '@/config.js';

let showLocaleChange = true;// 是否显示语言切换按钮

// let baseURL = "http://api.new.com/";// 本地测试环境接口域名
// let baseURL = "https://test.api.v1.yywd.vip/";// 云端测试环境接口域名
let baseURL = "https://branch.shop.api.yywd.vip/";// 云端测试环境接口域名
let adminURL = "https://branch.shop.api.yywd.vip/"; // 云端测试环境接口域名
let oldPlatform = "http://test.yywd.vip/";// 老项目地址
// let baseURL = "https://huawei.api.v1.yywd.vip/";// 华为云端测试环境接口域名
if (window.location.host.startsWith('shop.psi.yywd.vip')) {
    config.debug = false;
    adminURL = "https://api.v1.yywd.vip/"; // 生产环境接口域名
    baseURL = "https://shop.api.yywd.vip/";// 生产环境接口域名
    oldPlatform = "http://account.yywd.vip/";// 生产环境老项目地址
    showLocaleChange = false;// 生产环境不显示语言切换按钮
} else if (window.location.host.startsWith('test.shop.psi.yywd.vip')) {
    config.debug = false;
    adminURL = "https://test.api.v1.yywd.vip/"; // 云端测试环境接口域名
    baseURL = "https://test.shop.api.yywd.vip/";// 云端测试环境接口域名
    oldPlatform = "http://test.yywd.vip/";// 云端测试环境老项目地址
} else if (window.location.host.startsWith('branch.shop.psi.yywd.vip')) {
    config.debug = false;
    adminURL = "https://branch.api.v1.yywd.vip/"; // 云端测试环境接口域名
    baseURL = "https://branch.shop.api.yywd.vip/";// 云端测试环境接口域名
    oldPlatform = "http://branch.yywd.vip/";// 云端测试环境老项目地址
} else if (window.location.host.startsWith('beta.shop.psi.yywd.vip')) {
    config.debug = false
    adminURL = "https://beta.api.v1.yywd.vip/"; // 云端测试环境接口域名
    baseURL = 'https://beta.shop.api.yywd.vip/' // 云端测试环境接口域名
    oldPlatform = "https://beta.yywd.vip/";// 云端测试环境老项目地址
} else if (window.location.host.startsWith('tmp.shop.psi.yywd.vip')) {
    config.debug = false
    adminURL = "http://tmp.api.v1.yywd.vip/"; // 云端测试环境接口域名
    baseURL = 'http://tmp.shop.api.yywd.vip/' // 云端测试环境接口域名
    oldPlatform = "http://tmp.yywd.vip/";// 云端测试环境老项目地址
}

const Headers = {
    debug: false,//for test
    "request-from": "ShopFront",
};

export default {
    BaseURL: baseURL,
    OldPlatform: oldPlatform,
    Headers,
    showLocaleChange: showLocaleChange,
    AdminURL: adminURL
}